<template>
  <div class="messenger-not-found">
    <div class="messenger-not-found__content">
      <div class="messenger-not-found__icon">
        <feather-icon
          icon="SearchIcon"
        />
      </div>
      <div class="messenger-not-found__query">
        По запросу
          <span
            v-if="currentTags.length"
            v-for="tag in currentTags"
            :key="tag.slug"
          >
            {{ `"#${tag.name}"` }}
          </span>
          <span
            v-if="currentSearch"
          >
            {{ currentSearch }}
          </span>
        ничего не найдено
      </div>
      <div class="messenger-not-found__text">
        Попробуйте поискать по другим параметрам
      </div>
      <div class="messenger-not-found__link">
        <router-link
          :to="{
            name: 'chats',
            query: {}
          }"
        >
          Все чаты
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  watch: {
    '$route.query': {
      deep: true,
      handler () {
        this.$emit('not-found', false)
      }
    }
  },

  computed: {
    ...mapGetters(['currentTags', 'currentSearch'])
  }
}
</script>
